var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBellcomponent = function SvgBellcomponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 17,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 7.167v4.166L13.667 13v.833H.333V13L2 11.333V7.167C2 4.6 3.358 2.467 5.75 1.9v-.567C5.75.642 6.31.083 7 .083c.692 0 1.25.559 1.25 1.25V1.9C10.633 2.467 12 4.608 12 7.167Zm-3.333 7.5a1.666 1.666 0 1 1-3.333 0h3.333Z",
    fill: "#413E3B"
  })));
};
export default SvgBellcomponent;